import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useRouteError} from 'react-router-dom';
import ErrorFallbackMessage from './ErrorFallbackMessage';
import {getLinkPath} from 'app/utils/link_helper';
import {reportClientError} from 'app/utils/reportClientError';

const FALLBACK_PATH = '/play/bets';
const REDIRECT_COOLDOWN_MS = 10000;

let lastRedirectAt = 0;

const stripTrailingSlash = (path: string): string => path.replace(/\/+$/u, '');

const canRedirect = (pathname: string, now: number): boolean => {
    const onFallbackPage = stripTrailingSlash(pathname) === stripTrailingSlash(getLinkPath(FALLBACK_PATH));

    return !onFallbackPage && now - lastRedirectAt > REDIRECT_COOLDOWN_MS;
};

const RouteErrorFallback = (): React.ReactElement | null => {
    const error = useRouteError();
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const [showFallback, setShowFallback] = useState(false);

    useEffect(() => {
        reportClientError(error, pathname);

        if (canRedirect(pathname, Date.now())) {
            lastRedirectAt = Date.now();
            navigate(getLinkPath(FALLBACK_PATH), {replace: true});
        } else {
            setShowFallback(true);
        }
    }, [
        error,
        navigate,
        pathname
    ]);

    return showFallback ? <ErrorFallbackMessage/> : null;
};

export default RouteErrorFallback;
